import React from 'react';
import { Stack, Typography } from '@mui/material';

// Components
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import Table from 'src/components/Table';

// Utilities
import { IPortContainerType, ITradePortDetailInfo } from 'src/utils/typings/response';
import { useQueryDataContainerType } from 'src/services/queries';
import { IsLastType, StyledWhiteBox } from 'src/features/PortDetail/config';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import ContainersTerminalChart from 'src/features/PortDetail/TrafficThroughput/ContainersTerminalChart';
import DistributionCenterTable from 'src/features/PortDetail/TrafficThroughput/DistributionCenterTable';

interface IProps {
  portDetail: ITradePortDetailInfo | null;
}

const TrafficThroughputTab = ({ portDetail }: IProps) => {
  const { data, isFetching } = useQueryDataContainerType({ locode: portDetail?.meta?.locode || '' });
  const dataContainerType = getArrayDefault(data?.data);

  const configColumn: ConfigCell<IPortContainerType>[] = [
    {
      id: 'container_type',
      disablePadding: true,
      disableSort: true,
      label: 'Container Type',
      cell: (row: IPortContainerType) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderTextOrDefault(row?.container_type)}
          </Typography>
        );
      },
    },
    {
      id: 'exports',
      disablePadding: true,
      disableSort: true,
      label: 'Exports',
      cell: (row: IPortContainerType) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderTextOrDefault(row?.exports)}
          </Typography>
        );
      },
    },
    {
      id: 'imports',
      disablePadding: true,
      disableSort: true,
      label: 'Imports',
      cell: (row: IPortContainerType) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderTextOrDefault(row?.imports)}
          </Typography>
        );
      },
    },
  ];

  return (
    <React.Fragment>
      <Stack direction="column" spacing={3}>
        <StyledWhiteBox display="flex" flexDirection="column" gap={2}>
          <Typography variant="h5" align="left">
            Throughput by container type
          </Typography>
          <Table
            data={dataContainerType}
            configColumn={configColumn}
            dataKey="container_type"
            isPagination={false}
            loading={isFetching}
            maxRow={10}
            totalRecords={dataContainerType.length}
          />
        </StyledWhiteBox>
        <ContainersTerminalChart
          locode={portDetail?.meta?.locode || ''}
        />
        <Stack direction="row" spacing={1.5}>
          <DistributionCenterTable locode={portDetail?.meta?.locode || ''} isLast={IsLastType.Inbound} />
          <DistributionCenterTable locode={portDetail?.meta?.locode || ''} isLast={IsLastType.Outbound} />
        </Stack>
      </Stack>
    </React.Fragment>
  );
};

export default TrafficThroughputTab;
